import React from 'react'
import { useIntl } from 'react-intl'
import { mdiAlertCircleOutline } from '@mdi/js'

import theme from 'theme_'
import { MdiIcon } from 'components/Icons'
import { ResentWrapper, TwoFaInputWrapper } from './styles'
import { loginMessages } from '../../messages'

import CommonButton from 'components/Button/CommonButton'
import LoginCommonLayout from '../LoginCommonLayout'
import { StyledMainHeading } from '../MainHeading/MainHeading'
import { StyledDescriptionText } from '../../styles'
import { VerificationFailedProps } from '../../types'

export default function VerificationFailed(props: VerificationFailedProps) {
  const { formatMessage } = useIntl()

  const { setFailedError, resend } = props

  return (
    <LoginCommonLayout>
      <StyledMainHeading>
        {formatMessage(loginMessages.verificationFailedHeader)}
      </StyledMainHeading>
      <TwoFaInputWrapper>
        <MdiIcon
          path={mdiAlertCircleOutline}
          color={theme.colors.error}
          size={3}
        />
      </TwoFaInputWrapper>

      <StyledDescriptionText>
        {formatMessage(loginMessages.verificationFailedError)}
      </StyledDescriptionText>

      <ResentWrapper>
        <CommonButton
          type="button"
          onClick={() => {
            resend()
            setFailedError(false)
          }}
        >
          {formatMessage(loginMessages.resendCodeButton)}
        </CommonButton>
        <CommonButton
          type="button"
          variant="primary"
          onClick={() => setFailedError(false)}
        >
          {formatMessage(loginMessages.tryAgainButton)}
        </CommonButton>
      </ResentWrapper>
    </LoginCommonLayout>
  )
}
